import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchEvents, resetStateEvents } from "../../app/slices/eventsSlice";
import LoadingContainer from "../../components/LoadingContainer/LoadingContainer";
import ErrorContainer from "../../components/ErrorContainer/ErrorContainer";
import AppDataTable from "../../components/AppDataTable/appDataTable";
import { Button } from "@mui/material";
import EventDialog from "./EventDialog";
import moment from "moment";
import { dateFormat } from "../../app/utils";

const EventManagement = () => {
  const { data, status, error } = useSelector(({ events }) => events.get);
  const [list, setList] = useState(null);

  const [isOpenDialog, setIsOpenDialog] = useState(false);
  const [method, setMethod] = useState("ADD");
  const [selectedEvent, setSelectedEvent] = useState(null);
  const dispatch = useDispatch();

  const columns = [
    {
      name: "published_date_alt",
      label: "Date Posted",
    },
    {
      name: "event_date_alt",
      label: "Event Date",
    },
    {
      name: "title",
      label: "Title",
    },
    {
      name: "description_alt",
      label: "Description",
    },
    {
      name: "statusDisplay",
      label: "Status",
      options: {
        align: "center",
      },
    },
  ];

  //use effects
  useEffect(() => {
    loadResources();
    return () => {
      dispatch(resetStateEvents());
    };
  }, []);

  useEffect(() => {
    if (data?.length > 0) {
      let _list = [];
      data?.forEach((row) => {
        _list.push({
          ...row,
          published_date_alt: moment(row?.published_date).format(dateFormat),
          event_date_alt: moment(row?.event_date_alt).format(dateFormat),
          statusDisplay:
            row?.status === "A"
              ? "Active"
              : row?.status === "I"
              ? "Inactive"
              : row?.status,
          description_alt:
            row?.description?.length > 60
              ? `${row?.description?.substring(0, 59)}...`
              : row?.description,
        });
      });
      setList(_list);
    } else {
      setList([]);
    }
  }, [data]);

  //methods
  const loadResources = () => {
    dispatch(resetStateEvents());
    dispatch(fetchEvents());
  };

  //builders
  return (
    <>
      <div className="app-padding mt-20 mb-50">
        <Button
          variant="outlined"
          onClick={() => {
            setMethod("ADD");
            setSelectedEvent(null);
            setIsOpenDialog(true);
          }}
        >
          + Post Event
        </Button>

        {status === "idle" && error === null && list && (
          <AppDataTable
            id="Events-list"
            actions={[
              {
                action: "View",
                onClick: (item) => {
                  setMethod("VIEW");
                  setSelectedEvent({
                    ...item,
                    eventDate: moment(item?.event_date).format("YYYY-MM-DD"),
                    eventId: item?.event_id,
                  });
                  setIsOpenDialog(true);
                },
              },
              {
                action: "Update",
                onClick: (item) => {
                  setMethod("UPDATE");
                  setSelectedEvent({
                    ...item,
                    eventDate: moment(item?.event_date).format("YYYY-MM-DD"),
                    eventId: item?.event_id,
                  });
                  setIsOpenDialog(true);
                },
              },
            ]}
            columns={columns}
            data={list}
            emptyMessage="No Events found."
            rowsPerPageOptions={[10, 20, 50, 100]}
            downloadFileName={`TzFincert Events ${moment().format(
              "DD-MMM-YYYY"
            )}`}
          />
        )}
        {status === "loading" && (
          <LoadingContainer message={"Loading Events..."} />
        )}
        {status !== "loading" && error && (
          <ErrorContainer message={error?.message} onReload={loadResources} />
        )}
      </div>

      {/* Event dialog */}
      {isOpenDialog && (method === "UPDATE" ? selectedEvent : true) && (
        <EventDialog
          selectedEvent={selectedEvent}
          open={isOpenDialog}
          method={method}
          onClose={(refresh) => {
            setIsOpenDialog(false);
            if (refresh) {
              setSelectedEvent(null);
              if (refresh) {
                loadResources();
              }
            }
          }}
          readOnly={method === "VIEW"}
          title={
            method === "VIEW"
              ? "View Event"
              : method === "ADD"
              ? "Post Event"
              : "Update Event"
          }
        />
      )}
      {/* Event dialog */}
    </>
  );
};

export default EventManagement;
